import PropTypes from 'prop-types'
import { User } from '@phosphor-icons/react'

import { getAssetLink } from '../../../helpers/get-asset-link'

const AttendeeName = ({ avatarUrl, firstLine, secondLine }) => {
  return (
    <div className="attendee_name-cell">
      {avatarUrl ? (
        <img
          src={getAssetLink({ path: 'chitown-avatar/avatar', file: avatarUrl })}
          className="attendee_avatar"
        />
      ) : (
        <div className="attendee_avatar attendee_avatar--placeholder">
          <User size={16} weight="fill" />
        </div>
      )}

      <p>
        <span>{firstLine}</span>
        <span>{secondLine}</span>
      </p>
    </div>
  )
}

AttendeeName.propTypes = {
  avatarUrl: PropTypes.string,
  firstLine: PropTypes.string,
  secondLine: PropTypes.string,
}

export default AttendeeName
